import { useContext } from 'react'
import { AlertContext, AlertContextInterface } from './AlertContextProvider'

export const useAlertContext = (): AlertContextInterface =>
  useContext(AlertContext)
